import { Paper } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import AzureSearchServiceHeaderToolbar from './Components/AzureSearchServiceHeaderToolbar';
import PermissionConstants from '../../Common/Constants/PermissionConstants';
import { PermissionsContext } from '../UIContainer/PermissionsWrapper';
import { azureSearchServiceService } from './AzureSearchServiceService';
import { Order } from '../../../Helpers/Literals';
import { AzureSearchService } from './Model/AzureSearchServiceModel';
import AzureSearchServiceConstants from './Common/Constants';
import { Loader } from '../../../Common/Components/Loader';
import { showToast } from '../../../lib/toast';
import ShowAzureSearchServiceData from './Components/AzureSearchServiceData';
import { useCustomerStyles } from '../../../Common/Styles';

interface RenderContentProps {
  loading: boolean;
}

const ShowCannotViewAzureSearchServiceWarning = () => {
  return (
    <div>
      <h4 style={{ textAlign: 'center' }}>
        {AzureSearchServiceConstants.AzureSearchServicePermissionWarn}
      </h4>
    </div>
  );
};

const AzureSearchServiceHome = () => {
  const rowsPerPage = 8;
  const { classes } = useCustomerStyles();
  const permissions = useContext(PermissionsContext);
  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] =
    React.useState<keyof AzureSearchService>('Name');

  const initialState: AzureSearchService[] = [];
  const [AzureSearchServices, setAzureSearchServices] =
    React.useState(initialState);
  const [AzureSearchServicesCopy, setAzureSearchServicesCopy] =
    React.useState(initialState);
  const [loading, setLoadingState] = React.useState(true);

  useEffect(() => {
    loadAzureSearchServiceData();
  }, []);
  const loadAzureSearchServiceData = async () => {
    try {
      const azureSearchServicesRevieved =
        await azureSearchServiceService.getAzureSearchServices();
      setAzureSearchServices(azureSearchServicesRevieved.Items);
      setAzureSearchServicesCopy(azureSearchServicesRevieved.Items);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingState(false);
    }
  };

  const DeleteAzureSearchService = async (Name: string) => {
    if (
      window.confirm(AzureSearchServiceConstants.AzureSearchServiceDeleteWarn)
    ) {
      try {
        setLoadingState(true);
        await azureSearchServiceService.deleteAzureSearchService(Name);
        setAzureSearchServices(
          AzureSearchServices.filter((sa) => sa.Name !== Name),
        );
        showToast({
          type: 'success',
          title: AzureSearchServiceConstants.AzureSearchServiceDeleteSuc,
        });
        setLoadingState(false);
      } catch (error) {
        console.error(error);
        showToast({
          type: 'error',
          title: (error as Error).message,
        });
      } finally {
        setLoadingState(false);
      }
    }
  };

  function handleRequestSort(
    event: React.MouseEvent<unknown>,
    property: keyof AzureSearchService,
  ) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  function handleChangePage(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) {
    setPage(newPage);
  }

  const handleFilter = (searchFilterText: string) => {
    const filteredAzureSearchServices = AzureSearchServicesCopy.filter(
      function (azureSearchService) {
        return (
          azureSearchService.Name.toLowerCase().indexOf(
            searchFilterText.toLowerCase(),
          ) >= 0
        );
      },
    );
    setAzureSearchServices(filteredAzureSearchServices);
  };

  function handleSearchFilter(event: React.ChangeEvent<HTMLInputElement>) {
    handleFilter(event.target.value);
  }

  function canViewAzureSearchServices(): boolean {
    return !!(
      permissions[PermissionConstants.AzureSearchServiceReader] ||
      permissions[PermissionConstants.AzureSearchServiceWriter]
    );
  }

  const RenderContent = ({ loading }: RenderContentProps) => {
    if (loading) {
      return <Loader loading={loading} />;
    } else if (canViewAzureSearchServices()) {
      return (
        <ShowAzureSearchServiceData
          classes={classes as Record<string, string>}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          page={page}
          rowsPerPage={rowsPerPage}
          services={AzureSearchServices}
          onPageChange={handleChangePage}
          onDelete={DeleteAzureSearchService}
        />
      );
    } else {
      return <ShowCannotViewAzureSearchServiceWarning />;
    }
  };

  return (
    <>
      <AzureSearchServiceHeaderToolbar onFilterRequest={handleSearchFilter} />
      <Paper>
        <RenderContent loading={loading} />
      </Paper>
    </>
  );
};

export default AzureSearchServiceHome;
